export const ITEM_SEARCH_ORDER_BY_FIELDS = {
    name: 'name',
    sku: 'sku',
    category: 'categoryName',
    manufacturer: 'manufacturerName',
} as const;
